var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.47 746.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6579f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.13,116.66S67,115.71,4.66,348.81c0,0-60.29-280.89,252.71-301.89,0,0,410.58-222.92,300.29,303C557.66,350,482.9,170.4,280.13,116.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.67 348.81 2.9 724.22 57.12 724.22 57.12 235.33 38.37 216.92 4.67 348.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "557.66 349.96 547.96 746.8 496.6 746.8 507.18 268.44 542.13 276.46 557.66 349.96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset15);
export default __webpack_public_path__ + "static/media/Asset 15.46f1e215.svg";
export { ForwardRef as ReactComponent };